import { useId } from 'react';
import { cn } from '@/utils/tailwind.util';
export const GradientMask = ({
  backgroundColor,
  height = 90,
  className
}: {
  backgroundColor: string;
  height?: number;
  className?: string;
}) => {
  const uniqueId = useId();
  const maskId = `mask-${uniqueId}`;
  const gradientId = `gradient-${uniqueId}`;
  return <div className={cn('h-full', className)} data-sentry-component="GradientMask" data-sentry-source-file="GradientMask.tsx">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height={height} viewBox={`0 0 20 ${height}`} fill="none" style={{
      display: 'block',
      height: '100%'
    }} data-sentry-element="svg" data-sentry-source-file="GradientMask.tsx">
        <mask id={maskId} style={{
        maskType: 'alpha'
      }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height={height} data-sentry-element="mask" data-sentry-source-file="GradientMask.tsx">
          <rect width="20" height={height} fill={`url(#${gradientId})`} data-sentry-element="rect" data-sentry-source-file="GradientMask.tsx" />
        </mask>
        <g mask={`url(#${maskId})`} data-sentry-element="g" data-sentry-source-file="GradientMask.tsx">
          <rect x="-9.8335" y="0" width="38.2313" height={height} fill={backgroundColor} data-sentry-element="rect" data-sentry-source-file="GradientMask.tsx" />
        </g>
        <defs data-sentry-element="defs" data-sentry-source-file="GradientMask.tsx">
          <linearGradient id={gradientId} x1="0" y1={height / 2} x2="20" y2={height / 2} gradientUnits="userSpaceOnUse" data-sentry-element="linearGradient" data-sentry-source-file="GradientMask.tsx">
            <stop stopColor="#D9D9D9" stopOpacity="0" data-sentry-element="stop" data-sentry-source-file="GradientMask.tsx" />
            <stop offset="1" stopColor="#737373" data-sentry-element="stop" data-sentry-source-file="GradientMask.tsx" />
          </linearGradient>
        </defs>
      </svg>
    </div>;
};